import { FilterHandler } from '@btime/react-contexts'
import { capitalizeAll } from '@btime/helpers'
import { useLoggedUser, useProjectId } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'
import moment from 'moment'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { UserAvatar } from '../../../components/presentation/Avatar'
import { useDashActiveTab } from './tabs/_helpers'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import ControlBar from './ControlBar'
import FullScreenContent from '../../../packages/kiti/components/helpers/fullScreen/FullScreenContent'
import FullScreenContext from '../../../packages/kiti/components/helpers/fullScreen/FullScreenContext'
import GenericState from '../../../packages/kiti/components/helpers/GenericState'
import PermissionChecker from '../../session/_shared/PermissionChecker'
import ScreensLoader from './_load/ScreensLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import WidgetsGrid from '../../../containers/screens/widgets/WidgetsGrid'
import { getWorkspaceName } from '../../../utils/session/sessionStorage'
import { useNewFeature } from '../../../utils/contexts/NewFeature'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { METABASE_DASHBOARD_URLS } from './constants/metabase'

const DashboardPage = ({ entity, id }) => {
  const { t } = useTranslation('dashboard')
  const user = useLoggedUser()
  const screen = useDashActiveTab()

  const { isActive } = useNewFeature('PROCESSES')
  const navigate = useNavigation()

  if (isActive) navigate('/processes')

  return (
    <Separator weight={6}>
      <Grid justify="space-between" align="center" gap={3}>
        <Col flex={1}>
          <Title color="dark2" size="h3" bold noMargin>
            {t('welcome', { name: capitalizeAll(user.name) })}
          </Title>
          <SmallText color="dark2">{t('welcomeMessage')}</SmallText>
        </Col>

        <Col width={2}>
          <UserAvatar user={user} />
        </Col>
      </Grid>

      <Separator weight={9} />

      <FilterHandler
        tempStorageNamespace="dashboard"
        initialState={{
          fixedFilterFields: ['date'],
          filter: { date: [moment().startOf('month').toISOString(), moment().endOf('month').toISOString()] }
        }}
      >
        <FullScreenContent>
          <ControlBar />

          <Separator weight={4} />

          {screen && <WidgetsGrid screen={screen} />}
        </FullScreenContent>
      </FilterHandler>
    </Separator>
  )
}

const MetabaseDashboard = ({ url }) => {
  const { t } = useTranslation('dashboard')
  return (
    <div style={{ height: '100vh' }}>
      <iframe src={url} title={t('dashboardTitle')} width="100%" height="100%" style={{ border: '0' }} />
    </div>
  )
}

const Wrapper = props => {
  const project = useProjectId()
  const workspace = getWorkspaceName() || []
  const metabaseDashboardUrl = METABASE_DASHBOARD_URLS[workspace]?.find(item => item.projectId === project)?.url

  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor="white">
      <PermissionChecker permission="seeDashboard" hideMessage>
        <ScreensLoader>
          <GenericState initialState={{ editing: false, activeTabIndex: 0 }}>
            <FullScreenContext>
              {!!metabaseDashboardUrl ? <MetabaseDashboard url={metabaseDashboardUrl} /> : <DashboardPage {...props} />}
            </FullScreenContext>
          </GenericState>
        </ScreensLoader>
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default Wrapper
